import type { Breakpoint } from '@mui/system';

import { createTheme } from '../theme';

const dialogWidths: Record<Breakpoint, `${number}px` | '100dvw'> = {
  xs: '512px',
  sm: '640px',
  md: '800px',
  lg: '960px',
  xl: '1280px',
  mobile: '100dvw',
  tablet: '720px',
  desktop: '960px',
};

const theme = createTheme({
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: ({ theme: { unstable_sx: sx }, ownerState: { fullScreen, maxWidth } }) => {
          if (fullScreen) {
            return sx({
              maxWidth: '100dvw',
              maxHeight: '100dvh',
            });
          }

          return sx({
            width: '100%',
            maxWidth: maxWidth ? dialogWidths[maxWidth] : undefined,
            borderRadius: 2,
            boxShadow: ' 0px 16px 24px rgba(52, 58, 64, 0.15)',
          });
        },
      },
      defaultProps: {
        disableRestoreFocus: true,
        maxWidth: 'md',
      },
    },
    MuiDialogTitle: {
      defaultProps: {
        component: 'h3',
      },
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx, typography } }) =>
          sx({
            ...typography.h3,
            p: 3,
            wordBreak: 'break-all',
          }),
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx } }) =>
          sx({
            p: 3,
            wordBreak: 'break-all',
          }),
      },
    },
    MuiDialogActions: {
      defaultProps: {
        disableSpacing: true, // NOTE: add this to disable all margin for dialog margin, follow by design
      },
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx } }) => sx({ p: 3, gap: 1.5 }),
      },
    },
  },
});

export default theme.components;
